import { ResetPassword } from 'module/authentication/components/reset-password';
import { useAuthenticateLinks } from 'helpers/use-authenticate-links';

export const ResetPasswordPage = () => {
  const links = useAuthenticateLinks();

  return <ResetPassword links={links} />;
};
